<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <label class="label-input">Content</label>
          <v-text-field v-model="fields.sectionTitle" label="Name" />
          <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
            <label for="showLineStroke" style="margin-bottom: 0">Line</label>
            <input type="checkbox" v-model="fields['lineStroke'].show" id="showLineStroke" />
          </div>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field v-model="fields.lineStroke.width" label="Width" />
            </v-col>
            <v-col cols="12" md="6">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="lineStrokeColor"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields.lineStroke.color"
                  @change="handleChangeLineStrokeColor"
                />
                <v-text-field v-model="fields.lineStroke.color" label="Color" />
              </div>
            </v-col>
          </v-row>

          <v-col cols="12" md="6"></v-col>
          <v-text-field v-model="fields.sectionDescription" label="Description" />
          <div style="margin-bottom: 20px">
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                name="sectionBackground"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields['sectionBackground']"
                @change="handleChangeSectionBackground"
              />
              <v-text-field v-model="fields['sectionBackground']" label="Background Color" />
            </div>
          </div>
        </div>
        <div>
          <div class="d-flex justify-space-between align-center">
            <div>
              <label style="margin-bottom: 0" class="label-input">Items</label>
            </div>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, i) in fields['listItem']" :key="i">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>Item {{ i + 1 }}</span>
                  <v-btn icon @click.stop="handleRemoveItem(i)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="">
                  <div class="mb-6">
                    <UploadImage
                      @callback="obj => handleUploadImage(obj, i)"
                      :image="{ imageSrc: item.image }"
                      :height="`250`"
                      :typeUpload="'image'"
                      @callbackDelete="handleRemoveUpload(i)"
                    />
                  </div>
                  <div>
                    <label>Description:</label>
                    <ckeditor :editor="editor" v-model="item.htmlText" :config="editorConfig" />
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { replaceImageUrl } from '../common/utils';
export default {
  name: 'marquee-tino',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        sectionBackground: '',
        sectionTitle: '',
        sectionDescription: '',
        lineStroke: {
          show: false,
          width: 100,
          color: '#000000',
        },
        listItem: [
          // {
          //   image: "",
          //   htmlText: "",
          // }
        ],
        topPadding: true,
        bottomPadding: true,
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionMarqueeTino(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleChangeTextColor(event) {
      this.fields['text-color'] = event.target.value;
    },
    handleResetTextColor() {
      this.fields['text-color'] = '';
    },
    handleChangeSectionBackground(event) {
      this.fields['sectionBackground'] = event.target.value;
    },
    handleChangeLineStrokeColor(event) {
      this.fields.lineStroke.color = event.target.value;
    },
    handleUploadImage(obj, index) {
      this.fields['listItem'][index].image = obj.imageSrc;
    },
    handleRemoveUpload(index) {
      this.fields['listItem'][index].image = '';
    },
    handleAddItem() {
      this.fields['listItem'].push({
        image: replaceImageUrl(
          'https://cdn.skyfastimg.com/images/2025/10/29/image-690172fb465ce7ecf1a0cfa2.webp?w=50&amp;h=50&amp;q=80',
        ),
        htmlText: ` <h2 style="text-align:center;"><strong>Organically Grown</strong></h2>
              <p style="text-align:center;">No pesticides, fertilizers or nasties</p>`,
      });
    },
    handleRemoveItem(index) {
      this.fields['listItem'].splice(index, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.ck-editor__editable_inline {
  min-height: 300px;
}
.ck-editor__editable {
  min-height: 300px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
